import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IWifiAnalyzerResults} from '../../../../../services/AngularServices/WifiAnalyzerService';
import {cellTower, satelliteAltOutlined, smallTethering} from '../../icons';
import {ITranslate} from '../../../../../services/LocalizationService';
import {observer} from 'mobx-react';

interface ChannelsTabProps {
    platformType: string;
    channelAnalysis: IWifiAnalyzerResults['channelAnalysis'];
    isScanning: boolean;
    onStartScan: () => void;
    translate: ITranslate;
    getCurrentColorByPoint: (point: number) => string;
}

@observer
export class ChannelsTab extends TechseeBaseComponent<ChannelsTabProps> {
    renderInternal() {
        const {channelAnalysis, translate, getCurrentColorByPoint} = this.props;

        return (
            <div className='tab-box-container'>
                <div className='tab-box-icons-and-description padding-10'>
                    <div className={'icon'}>{smallTethering}</div>
                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.CHANNELS')} </span>
                </div>

                {channelAnalysis &&
                    channelAnalysis.map((item, idx) => (
                        <div key={idx} className='channel-box'>
                            <div className='tab-box-left-panel'>
                                <div className='tab-box-icons-and-description padding-0 margin-b-0'>
                                    <div className={'icon'}>{smallTethering}</div>
                                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.CHANNELS')} </span>
                                    <span> {item.channel} </span>
                                </div>
                                <div className='tab-box-icons-and-description padding-0 margin-b-0'>
                                    <div className={'center icon'}>{cellTower}</div>
                                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.ACCESS_POINT')} </span>
                                    <span
                                        className={'center bold-500'}
                                        style={{color: `${getCurrentColorByPoint(item.totalAP)}`, paddingLeft: '6px'}}>
                                        {item.totalAP}
                                    </span>
                                </div>
                            </div>
                            <div className='tab-box-right-panel'>
                                <div className='tab-box-icons-and-description margin-b-0'>
                                    <div className={'icon'}>{satelliteAltOutlined}</div>
                                    <span> {translate('CONNECTIVITY_GURU.WIFI_SCAN.FREQUENCY')} </span>
                                    <span>
                                        {String(item.freq).toLowerCase().endsWith('ghz')
                                            ? item.freq
                                            : `${item.freq}GHz`}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        );
    }
}
